// Component/Sidebar/Sidebar.js
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { influencerLogout } from '../../Services/Operations/ProductAPI';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../Redux/user_information';

const Sidebar = () => {
  const navigate = useNavigate();
    const dispatch = useDispatch();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [logoutError, setLogoutError] = useState(null);
    const { token, loginData } = useSelector(state => state.influencer);

  const menuItems = [
    { path: '/dashboard', icon: '📊', label: 'Dashboard' },
    { path: '/commissions', icon: '💰', label: 'Commissions' },
    { path: '/payments', icon: '💳', label: 'Payments' },
    { path: '/profile', icon: '👤', label: 'Profile' },
  ];

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true);
      setLogoutError(null);

      const token = localStorage.getItem('influencerToken');

      const tokenFromCookies = document.cookie
        .split('; ')
        .find(row => row.startsWith('influencerToken='))
        ?.split('=')[1];

      const finalToken = token || tokenFromCookies;

      if (finalToken) {
        try {
          await influencerLogout(finalToken);
        } catch (apiError) {
          console.warn('API logout failed, proceeding with local logout:', apiError);
       
        }
      }

      dispatch(logout());
      console.log('Logged out successfully - all data cleared');

      navigate('/login');

    } catch (error) {
      console.error('Logout error:', error);
      setLogoutError('Failed to logout. Please try again.');

      dispatch(logout());

      navigate('/login');

    } finally {
      setIsLoggingOut(false);
    }
  };
  const handleConfirmLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      handleLogout();
    }
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <span className="logo-text">Roam Influencer</span>
        </div>
      </div>
      
      <nav className="sidebar-nav">
        <ul className="nav-menu">
          {menuItems.map((item) => (
            <li key={item.path} className="nav-item">
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `nav-link ${isActive ? 'active' : ''}`
                }
                end={item.path === '/dashboard'}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      
      <div className="sidebar-footer">
        {logoutError && (
          <div className="logout-error">
            {logoutError}
          </div>
        )}
        
        <button 
          className="logout-btn" 
          onClick={handleConfirmLogout}
          disabled={isLoggingOut}
        >
          <span className="logout-icon">
            {isLoggingOut ? '⏳' : '🚪'}
          </span>
          {isLoggingOut ? 'Logging out...' : 'Logout'}
        </button>
        
        {/* <div className="user-info">
          {(() => {
            const profile = JSON.parse(localStorage.getItem('influencerProfile') || '{}');
            return (
              <div className="user-details">
                <span className="user-name">{profile.name || 'User'}</span>
                <span className="user-email">{profile.email || ''}</span>
              </div>
            );
          })()}
        </div> */}
      </div>
    </aside>
  );
};

export default Sidebar;